import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { useSession } from '../auth/hooks';
export function useAdminGuard() {
    const { user, loading: authLoading } = useSession();
    const [isAdmin, setIsAdmin] = useState(null);
    const nav = useNavigate();
    useEffect(() => {
        if (authLoading)
            return;
        if (!user) {
            nav('/login?next=/app/admin');
            return;
        }
        (async () => {
            const { data } = await supabase.from('profiles').select('is_super_admin').eq('id', user.id).maybeSingle();
            const ok = !!data?.is_super_admin;
            setIsAdmin(ok);
            if (!ok)
                nav('/app/dashboard?denied=admin');
        })();
    }, [user, authLoading, nav]);
    return { isAdmin, loading: authLoading || isAdmin === null };
}
